import Model, { attr, belongsTo } from '@ember-data/model';
import { isNone } from '@ember/utils';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export const DEFAULT_BOOKING_WINDOW_DAYS = 365;

export default class BookingWindowRuleModel extends Model {
  @attr('number') windowDays!: number | null;

  @belongsTo('property', { async: false, inverse: null })
  property!: ModelRegistry['property'];

  @cached
  get isDisabled(): boolean {
    return isNone(this.windowDays);
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'booking-window-rule': BookingWindowRuleModel;
  }
}
